import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import { UtilService } from "../services";

export class SetPhlebotomistSearchCriteria implements ReduxAction {
  type: string = "SET_PHLEBOTOMIST_SEARCH_CRITERIA";
  SearchCriteria: SearchCriteria;

  constructor(searchCriteria: SearchCriteria) {
    this.SearchCriteria = searchCriteria;
  }

  get() {
    return this.SearchCriteria;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/phlebotomist-search.actions.ts